import { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { Card, CardContent } from "../components/ui/card";
import { Loader2, AlertCircle, Clock } from "lucide-react";
import { clientAuthAPI } from "../lib/api";
import ClientPortalPage from "./ClientPortalPage";

export default function ShortLinkPage() {
  const { code } = useParams();
  const [status, setStatus] = useState("resolving");
  const [token, setToken] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");
  const resolved = useRef(false);

  useEffect(() => {
    if (!code || resolved.current) return;
    resolved.current = true;

    const resolve = async () => {
      try {
        const res = await clientAuthAPI.resolveShortLink(code);
        setToken(res.data.token);
        setStatus("resolved");
      } catch (err) {
        const status = err?.response?.status;
        if (status === 410) {
          setErrorMsg("This link has expired. Please ask your coach for a new one.");
          setStatus("expired");
        } else {
          setErrorMsg("This link is invalid or has been removed.");
          setStatus("error");
        }
      }
    };
    resolve();
  }, [code]);

  if (status === "resolving") {
    return (
      <div className="min-h-screen flex items-center justify-center p-4" style={{ background: '#050505' }}>
        <div className="text-center space-y-4">
          <Loader2 className="w-8 h-8 animate-spin text-primary mx-auto" />
          <p className="text-sm text-muted-foreground">Loading your dashboard...</p>
        </div>
      </div>
    );
  }

  if (status === "expired") {
    return (
      <div className="min-h-screen flex items-center justify-center p-4" style={{ background: '#050505' }}>
        <Card className="glass-card max-w-md w-full">
          <CardContent className="p-8 text-center">
            <Clock className="w-12 h-12 text-amber-400 mx-auto mb-4" />
            <h2 className="text-xl font-bold text-foreground mb-2" data-testid="expired-link-title">Link Expired</h2>
            <p className="text-muted-foreground text-sm">{errorMsg}</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="min-h-screen flex items-center justify-center p-4" style={{ background: '#050505' }}>
        <Card className="glass-card max-w-md w-full">
          <CardContent className="p-8 text-center">
            <AlertCircle className="w-12 h-12 text-red-400 mx-auto mb-4" />
            <h2 className="text-xl font-bold text-foreground mb-2" data-testid="invalid-link-title">Invalid Link</h2>
            <p className="text-muted-foreground text-sm">{errorMsg}</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <ClientPortalPage shortLinkToken={token} />;
}
